async function getAllCountries(currentLocale) {
  try {
    const defaultLocale = 'en'
    const localeFiles = require.context(
      './countries',
      false,
      /[A-Za-z0-9-_,\s]+\.js$/i
    )
    const locales = localeFiles.keys().map((file) => {
      const matched = file.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        return matched[1]
      }
    })
    const locale = locales.includes(currentLocale)
      ? currentLocale
      : defaultLocale
    const localeFile = await import(`./countries/${locale}.js`)
    const countriesLength = Object.keys(localeFile).length
    const countries = []
    for (let i = 0; i < countriesLength - 1; i++) {
      countries.push({
        value: localeFile[i].code,
        text: localeFile[i].name
      })
    }

    return countries
  } catch (error) {
    throw {
      error: "LOCALE_FILE_LOAD_FAILED"
    }
  }
}

async function getCountryInfo(countryCode, locale) {
  try {
    const countries = await getAllCountries(locale)
    const countryInfo = countries.find((country) => {
      return country.value.toUpperCase() === countryCode.toUpperCase()
    })

    if (countryInfo) {
      return {
        cca2: countryInfo.value,
        name: countryInfo.text
      }
    }

    return null
  } catch (error) {
    throw {
      error: "GET_COUNTRY_INFO_FAILED"
    }
  }
}

export {
  getAllCountries,
  getCountryInfo,
}
